/* tslint:disable */
/* eslint-disable */
/**
 * quarkus-webapp API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.36.51
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  RestResult,
  SystemProperty,
} from '../models/index';
import {
    RestResultFromJSON,
    RestResultToJSON,
    SystemPropertyFromJSON,
    SystemPropertyToJSON,
} from '../models/index';

export interface GetSystemPropertyRequest {
    name: string;
}

export interface UpdateSystemPropertyRequest {
    property?: string;
    value?: string;
}

/**
 * 
 */
export class SystemProperty2ControllerApi extends runtime.BaseAPI {

    /**
     */
    async getSystemPropertiesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SystemProperty>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("SecurityScheme", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admsys/system-properties`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SystemPropertyFromJSON));
    }

    /**
     */
    async getSystemProperties(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SystemProperty>> {
        const response = await this.getSystemPropertiesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getSystemPropertyRaw(requestParameters: GetSystemPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SystemProperty>> {
        if (requestParameters['name'] == null) {
            throw new runtime.RequiredError(
                'name',
                'Required parameter "name" was null or undefined when calling getSystemProperty().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("SecurityScheme", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admsys/system-properties/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters['name']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SystemPropertyFromJSON(jsonValue));
    }

    /**
     */
    async getSystemProperty(requestParameters: GetSystemPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SystemProperty> {
        const response = await this.getSystemPropertyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateSystemPropertyRaw(requestParameters: UpdateSystemPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RestResult>> {
        const queryParameters: any = {};

        if (requestParameters['property'] != null) {
            queryParameters['property'] = requestParameters['property'];
        }

        if (requestParameters['value'] != null) {
            queryParameters['value'] = requestParameters['value'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("SecurityScheme", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admsys/system-properties`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RestResultFromJSON(jsonValue));
    }

    /**
     */
    async updateSystemProperty(requestParameters: UpdateSystemPropertyRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RestResult> {
        const response = await this.updateSystemPropertyRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
